import { SerializableObject } from './serializable-object';

export class VerificationId extends SerializableObject {
  public verificationId: string;
}
